<template>
    <div>
        <div v-if="isShow">
            <div class="select">
                <el-form ref="form" :model="form" label-width="150px">
                    <el-row v-if="type != 'resourcesCourse'">
                        <el-col :span="6">
                            <el-form-item label="课程名称：" prop="courseName">
                              <input type="text" v-model="form.courseName" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="课程代码：" prop="courseCode">
                              <input type="text" v-model="form.courseCode" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="考试方式：" prop="examinationType">
                                <el-select
                                    v-model="form.examinationType"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in examTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="type!=='baseCourse'">
                            <el-form-item label="建课学校："  prop="schoolName">
                                <input type="text" v-model="form.schoolName" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="type != 'resourcesCourse'">
                        <el-col :span="6" v-if="type==='baseCourse'">
                          <el-form-item label="课程学分" prop="coursePoint">
                             <input type="text" v-model="form.coursePoint" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="type!=='baseCourse'">
                            <el-form-item label="建课老师："  prop="teacherName">
                              <input type="text" v-model="form.teacherName" />
                                <!-- <el-select
                                    v-model="form.teacherName"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in teachers"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="type!=='baseCourse'">
                            <el-form-item label="课程属性：" prop="courseAttribute">
                                <el-select
                                    v-model="form.courseAttribute"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in courseAttributeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="type!=='baseCourse'">
                            <el-form-item label="考试类别：" prop="videoType">
                                <el-select
                                    v-model="form.videoType"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in [{id:'',videoTypeTitle:'-不限-'},...videoList]"
                                        :key="item.id"
                                        :label="item.videoTypeTitle"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="type==='totalCourse'">
                            <el-form-item label="状态：">
                                <el-select
                                    v-model="form.status"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in courseStatusList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="type === 'resourcesCourse'">
                        <el-col :span="6">
                            <el-form-item label="批次号/班级编码：">
                                <input type="text" v-model="form.batch" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="班级名称：">
                                <input type="text" v-model="form.albumTitle" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="课程状态：">
                                <el-select
                                    v-model="form.status"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in courseStatusList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="开课机构：" prop="rkMhmName">
                                <input type="text" v-model="form.rkMhmName" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="type === 'resourcesCourse'">
                        <el-col :span="6">
                          <el-form-item label="任课老师：">
                             <input type="text" v-model="form.rkTeacherName" />
                          </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="type === 'totalCourse'">
                        <el-col :span="6">
                          <el-form-item label="开课批次/班级：">
                             <input type="text" v-model="form.batch" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="班级名称：">
                             <input type="text" v-model="form.albumTitle" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="开课机构：">
                             <input type="text" v-model="form.rkMhmName" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="任课老师：">
                             <input type="text" v-model="form.rkTeacherName" />
                          </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="btn">
                <button
                  style="background-color: #409eff; border: 0; color: #fff;cursor:pointer"
                  @click="handleSearch"
                >
                    确认
                </button>
                <button @click="isShow = false" style="cursor:pointer">收起</button>
                <button @click="handleReset" style="cursor:pointer">清空</button>
            </div>
        </div>
        <div class="selectbtn">
            <button
                @click="isShow = true"
                style="background-color: #409eff; border: 0; color: #fff"
            >
                筛选
            </button>
            <el-button type="primary" size="small" @click="handleExport">导出结果</el-button>
        </div>
    </div>
</template>

<script>
import {getVideoType} from '@/api/TeacherClassroomManagement/MyClassroomTution'
export default {
    props:['type'],
    data() {
        return {
            isShow: false,
            // 考试方式
            examTypeList: [
              {label: "-不限-", value:''},
              {label: "笔试",value:'1'},
              {label: "实践考核",value:'2'}
            ],
            courseAttributeList:[
              {value:'',label: "-不限-"},
              {value:'1',label:'考核'},
              {value:'2',label:'培训'},
            ], // 课程属性
            videoList:[], // 考试类别
            courseStatusList:[
              {value:'',label:'-不限-'},
              {value:'开课中',label:'开课中'},
              {value:'未开课',label:'未开课'},
              {value:'已结课',label:'已结课'},
              {value:'未配置',label:'未配置'}
            ], // 课程状态
            teacher: "-不限-",
            albumTitle: "",
            form: {
              courseName:'',
              courseCode:'',
              examinationType:'',
              coursePoint:'',
              courseAttribute:'',
              videoType:"",
              schoolName:'',
              teacherName:'',
              status:''
            },
            coursePoint:''
        };
    },
    created(){
      this.getVideoTypes();
    },
    methods:{
      /** 筛选事件 */
      handleSearch(){
        this.$emit('change',this.form)
      },
      /** 重置事件 */
      handleReset(){
        // this.resetForm('form')
        this.form = {
          courseName:'',
          courseCode:'',
          examinationType:'',
          coursePoint:'',
          courseAttribute:'',
          videoType:"",
          schoolName:'',
          teacherName:'',
          status:''
        }
        this.$emit('change',this.form)
      },
      /** 导出结果事件 */
      handleExport(){
        this.$emit('export',this.form)
      },
      /** 获取考试类别 */
      async getVideoTypes(){
        let {data} = await getVideoType()
        this.videoList = data.data;
      }
    }
};
</script>

<style lang="scss" scoped>
input {
    display: inline-block;
    width: 206px;
    height: 32px;
    border: 1px solid #c0c4cc;
    border-radius: 5px;
}
.el-row {
    font-size: 16px;
}
.btn {
    text-align: center;
}
button {
    width: 73px;
    height: 28px;
    // border: 1px solid #000;
    border-radius: 5px;
    margin: 0 20px;
}
</style>